export default {
  hello: 'Hello',
  page: {
    example: 'Example page {name}'
  },
  other: 'Other',
  searchByNameProduct: 'Search by dish name',
  nothingFound: 'Nothing found',
  login: 'Login',
  password: 'Password',
  chooseLanguage: 'Choose language',
  restaurantWifi: 'Restaurant Wi-Fi',
  chipDialog: {
    gotIt: 'Got it',
    cashback: {
      title: 'Cashback',
      description: 'Money back when you pay at the venue.'
    },
    rating: {
      title: 'Rating',
      description: 'Venue rating based on guest reviews.'
    },
    avgBill: {
      title: 'Average check',
      description: 'Typical cost per person.'
    },
    workingHours: {
      title: 'Opening hours',
      description: 'Scheduled opening and closing times.'
    },
    address: {
      title: 'Address',
      description: 'Where the venue is located.'
    },
    openingHours: {
      title: 'Opening hours',
      description: 'Whether the venue is open now and when it opens or closes.'
    },
    avgCooking: {
      title: 'Preparation time',
      description: 'Typical time to prepare dishes.'
    },
    venueInfo: {
      title: 'About the venue',
      description:
        'Basic information about this place. For more details, ask the staff.'
    }
  },
  venueInfoModal: {
    close: 'Close',
    scheduleMode: 'Opening hours',
    call: 'Call',
    route: 'Route',
    taxi: 'Taxi',
    prep: 'Prep time',
    delivery: 'Delivery',
    avgCheck: 'Avg. check',
    rating: 'Rating',
    todaySuffix: ' (Today)',
    weekdays: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday'
    }
  },
  qrMenu: {
    passwordResetSuccessfully: 'Password reset successfully',
    unableToResetPassword: 'Unable to reset password',
    shareText: 'Check out the menu',
    openUntil: 'Open until {time}',
    opensAt: 'Opens at {time}',
    cookingMinutes: '{n} min',
    avgBillApprox: '~{amount} sum',
    menuLoadErrorTitle: 'Could not load menu',
    sourceCart: 'Cart',
    sourceMenu: 'Menu',
    orderLoadFailedTitle: 'Could not load order',
    orderPlaceFailedTitle: 'Could not place order',
    yourOrder: 'Your order',
    yourLastOrder: 'View your order',
    dishNames: 'Dishes',
    noOrderItems: 'No items in the order',
    summaryInfo: 'Summary',
    orderSum: 'Order total',
    currencySuffix: 'sum',
    orderPriceItems: '{count} items',
    orderPriceAction: 'Order',
    backToHome: 'Back to home',
    cartSectionAria: 'Cart',
    paymentSectionAria: 'Payment method',
    totalToPay: 'Total due:',
    cartEmpty: 'Your cart is empty',
    authDialogTitle: 'Sign in',
    storiesAlt: 'Stories',
    back: 'Back',
    orderUuidMissing: 'Order ID is missing',
    orderLoadFailed: 'Could not load order',
    orderParseFailed: 'Could not parse order response',
    tableOrderMissingTableId: 'Table link is invalid (missing table). Please scan the table QR code again.',
    orderErrorNoDetails: 'The order could not be processed. Please try again or contact the venue.',
    orderTableProgress: {
      awaiting: 'Order placed',
      awaiting_description: 'Waiting for the restaurant to confirm',
      preparing: 'The kitchen is preparing your order',
      preparing_description: 'Almost ready',
      prepared: 'Food is ready',
      prepared_description: 'Pickup or delivery will start shortly',
      delivering: 'On the way',
      delivering_description: 'Arriving soon',
      ready: 'Order completed',
      ready_description: 'Enjoy your meal'
    },
    cartPayment: {
      addCard: 'Add card',
      addCardPlaceholder: 'Add card',
      expiryPlaceholder: 'MM/YY',
      pay: 'Pay',
      savedCardAria: 'Card {pan}',
      orDivider: 'OR',
      addCardFailed: 'Could not add card',
      invalidCardNumber: 'Invalid card number',
      invalidCardExpiry: 'Invalid card expiry date'
    },
    cartComment: {
      title: 'Comment for restaurant',
      placeholder: 'Order notes, allergies, etc.',
      done: 'Done'
    },
    cartHeader: {
      backToMenuAria: 'Back to menu',
      clearCartAria: 'Clear cart'
    },
    cartActions: {
      addMore: 'Add more dishes'
    },
    cardAddFlow: {
      verifyTitle: 'Confirm card',
      verifyHint: 'Enter the 6-digit code from SMS',
      confirm: 'Confirm',
      addTitle: 'Add card',
      addHint: 'Enter card number and expiry date',
      cardNumberPlaceholder: 'Card number'
    },
    check: {
      yourBill: 'Your bill',
      billNumber: 'Bill #{n}',
      waiter: 'Server',
      tableNumber: 'Table number',
      tableLabel: 'table {n}',
      tipsHeading: 'Tip for server',
      noTip: 'No tip',
      saveTipNext: 'Save tip amount for the next order',
      paymentMethod: 'Payment method',
      summaryHeading: 'Summary',
      rowOrder: 'Order',
      rowTips: 'Tip',
      total: 'Total',
      continue: 'Continue',
      disclaimer:
        'Rachmat acts as an intermediary between you, the venue, and the delivery service provider. By confirming, you accept our Terms and Conditions and authorize us to process the order.',
      demoRestaurant: 'Asian Cuisine Restaurant',
      demoWaiter: 'Azamat',
      demoTableNumber: '5'
    },
    orderPaymentOtp: {
      title: 'Confirm payment',
      hint: 'Enter the code from SMS',
      confirm: 'Confirm',
      resendFailed: 'Could not resend the code',
      resendSent: 'Code sent again',
      missingCardToken: 'Card token is missing; cannot resend the code',
      cardConfirmed: 'Card successfully added',
      confirmFailed: 'Wrong code or card has expired'
    },
    confirmClearCart: {
      message: 'Are you sure you want to clear your previous cart?',
      header: 'Clear cart',
      cancel: 'Cancel',
      accept: 'Clear'
    },
    confirmPaymentFailed: 'Could not confirm payment',
    restaurantClosed: {
      title: 'Restaurant temporarily closed',
      description: 'The restaurant is not accepting orders at the moment. Please try again later.',
      retry: 'Retry'
    },
    confirmPaymentOtpFailed: 'Wrong code or payment was not confirmed',
    auth: {
      welcome: 'Welcome',
      phoneIntro: "Let's start with your phone number",
      phoneLabel: 'Phone number',
      smsTitle: 'SMS code',
      smsHintLine1: 'Enter the 4-digit code we sent',
      smsHintLine2: 'to you via SMS at {phone}',
      resendPrefix: 'Send again in',
      sendAgain: 'Send',
      getSmsCode: 'Get SMS code',
      signIn: 'Sign in',
      termsLine1: 'By creating an account, you automatically accept our Terms of Service,',
      termsPrivacy: 'Privacy Policy',
      termsAnd: 'and',
      termsCookie: 'Cookie Policy.'
    }
  },
  toast: {
    success: 'Success',
    error: 'Error',
    loginCopied: 'Login copied',
    passwordCopied: 'Password copied',
    productUnavailableSummary: 'Product unavailable',
    productUnavailableDetail: 'Item is temporarily out of stock'
  },
  redirectWindow: {
    openButton: 'Payment redirect screen',
    continueTo: 'Payment in the {system} app',
    redirectHint: 'You will be redirected to the {system} app to confirm the transaction',
    cancelPayment: 'Cancel'
  }
}
